<template>
    <website-page no-sub-menu>
        <b-container class="qr-code-section text-white" style="width: 700px">
            <h1 class="mx-auto mb-5 text-center" v-tr>Generate QR Code|Générer un code QR</h1>

            <b-form-group>
                <label class="mb-0" v-tr>Web page link to promote|Lien de la page web à promouvoir</label>
                <e-input v-model="data" autofocus @change="generateQrCode" state="disabled" maxlength="500" class="qr-input"></e-input>
            </b-form-group>

            <div class="d-flex justify-content-between">
                <div class="mr-5">
                    <b-form-group>
                        <label class="mb-2" v-tr>Add a logo|Ajouter un logo</label>

                        <div class="d-flex align-items-center">
                            <input ref="file" @input="onFileInput" type="file" accept="image/*" class="d-none">
                            <b-btn v-if="!image" @click.stop="$refs.file.click()" variant="light">
                                <span v-tr>Add an image|Ajouter une image</span>
                            </b-btn>

                            <b-img v-else @click.stop="$refs.file.click()" :src="image" width="150" height="100" class="image-preview" style="object-fit: cover"></b-img>

                            <b-btn v-if="image" @click.stop="removeImage" variant="light" class="ml-auto">
                                <span v-tr>Remove|Annuler</span>
                            </b-btn>
                        </div>
                    </b-form-group>

                    <b-form-group>
                        <label class="mb-2" v-tr>Color|Couleur</label>
                        <div class="colors" style="gap: 10px">
                            <div v-for="(c, index) in colors" :key="index" @click.stop="color = c" class="color" :style="`background: ${c}`">
                                <i v-if="color === c" class="fas fa-check"></i>
                            </div>
                        </div>
                    </b-form-group>

                    <b-form-group v-if="false">
                        <label v-tr>Size|Taille</label>
                        <b-input-group>
                            <e-input v-model="size" @change="generateQrCode" type="number" state="disabled" style="max-width: 200px"></e-input>
                            <b-input-group-append is-text>
                                <b>px</b>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div>
                    <div class="qr-code-container" :style="`background: ${this.color === '#fff' ? '#000' : '#fff'}`">
                        <div ref="qrCode"></div>
                    </div>
                </div>
            </div>

            <b-btn @click.stop="downloadQrCode" class="d-block px-4 py-3 mx-auto mt-5" style="font-size: 1.3rem">
                <span class="f-700" v-tr>Download QR Code|Télécharger le QR code</span>
                <i class="fas fa-cloud-download ml-2"></i>
            </b-btn>
        </b-container>
    </website-page>
</template>

<script>
import QRCodeStyling from 'qr-code-styling';
import EInput from "../../vue-components/components/e-input.vue";

export default {
    name: `qr-code-generator`,
    components: {EInput},
    data() {
        return {
            qrCode: null,
            data: `https://thefoodforce.com`,
            image: null,
            color: `#000`,
            size: 1000
        }
    },
    computed: {
        colors() {
            return [
                `#000`,
                `#d01e1e`,
                `#fa5151`,
                `#1d3bb7`,
                `#1991e7`,
                `#298c3d`,
                `#4cc42b`,
                `#69350a`,
                `#ff7600`,
                `#86185a`,
                `#e812a3`,
                `#fff`
            ];
        }
    },
    mounted() {
        this.generateQrCode();
    },
    methods: {
        onFileInput(event) {
            const file = event.target.files[0];

            if (!file)
                return;

            if (this.image) {
                URL.revokeObjectURL(this.image);
            }

            this.image = URL.createObjectURL(file);
            this.generateQrCode();
        },
        removeImage() {
            this.image = null;
            this.$refs.file.value = null;
            this.generateQrCode();
        },
        async downloadQrCode() {
            if (this.qrCode) {
                this.generateQrCode(true);
                await this.qrCode.download({
                    name: `qr`,
                    extension: `png`
                });
                this.generateQrCode();
            }
        },
        generateQrCode(forDownload = false) {
            this.qrCode = new QRCodeStyling({
                width: forDownload ? this.size : 300,
                height: forDownload ? this.size : 300,
                type: `svg`,
                data: this.data,
                image: this.image,
                dotsOptions: {
                    color: this.color,
                    type: `extra-rounded`
                },
                backgroundOptions: {
                    color: this.color === `#fff` ? `#000` : `rgba(255, 255, 255, 0)`
                },
                imageOptions: {
                    crossOrigin: `anonymous`,
                    margin: 3
                },
                cornersSquareOptions: {
                    type: `extra-rounded`
                }
            });

            if (forDownload) {
                this.qrCode.append(document.createElement(`div`));
            } else {
                QRCodeStyling._clearContainer(this.$refs.qrCode);
                this.qrCode.append(this.$refs.qrCode);
            }
        }
    },
    watch: {
        color() {
            this.generateQrCode();
        }
    }
}
</script>

<style lang="scss">
.qr-code-section {
    padding-top: 80px;
    padding-bottom: 80px;

    .qr-input {
        color: white;
        font-size: 1.5rem;
        background: transparent;
        border: 2px solid var(--primary) !important;
        margin-top: 10px;
        margin-bottom: 40px;
    }

    .image-preview {
        border-radius: 8px;
        cursor: pointer;
        margin-right: 50px;
    }

    .colors {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }

    .color {
        cursor: pointer;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        border: 2px solid white;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 150ms ease;

        &:hover {
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.95);
        }
    }

    .file-input {
        button {
            display: none !important;
        }
    }

    .qr-code-container {
        border-radius: 30px;
        overflow: hidden;
        padding: 10px;
    }
}
</style>
